export default __webpack_public_path__ + "static/media/s1.69341801.jpg";